// NOTE: NSAI-5680 — `messageRole` of a fact's resolved source
// (IUserMemoryFactSourceView) when the quoted message was written by the user;
// any other role is rendered as the assistant's words. Mirrors the server's
// EMessageRole.USER, which is what the message row stores.
export const USER_MEMORY_SOURCE_ROLE_USER = "user" as const;

// NOTE: NSAI-6369 — bounds on the exclusion list. Both are enforced on the
// client (so the editor can say what will happen before the save) and on the
// server (so a hand-written request cannot exceed them).
//
// 200 characters is a category, not an essay: "family details, including my
// children's names and schools" fits comfortably, while a paragraph of prose
// does not — and a paragraph would not work anyway, because these entries are
// listed to the extraction model, which reads a short list far more reliably
// than a wall of text. 30 entries for the same reason: past that the list stops
// being a set of categories and starts being a second system prompt.
export const USER_MEMORY_MAX_EXCLUSION_LENGTH = 200;
export const USER_MEMORY_MAX_EXCLUSION_CATEGORIES = 30;

// NOTE: NSAI-6371 — client-side mirrors of the server's per-item character cap
// (USER_MEMORY_MAX_FACT_CONTENT_LENGTH) and bulk-import size cap
// (USER_MEMORY_IMPORT_MAX_ITEMS). They exist so the import dialog can warn
// BEFORE a round trip which lines will not be stored; the server stays the
// authority and reports the real outcome per line, so if these ever drift the
// consequence is a warning that did not appear, not a memory silently lost.
export const USER_MEMORY_MAX_FACT_LENGTH = 300;
export const USER_MEMORY_IMPORT_MAX_ITEMS = 200;
